(function(){
  'use strict';  

  theme.MobileNav = (function() {
    var selectors = {
      wrapper: '.mobile-nav__wrapper',
      nav: '.mobile-nav',
      childList: '.mobile-nav__dropdown',
      allLinks: 'a.mobile-nav__link',
      subNavToggleBtn: '.js-toggle-submenu',
      openBtn: '.mobile-nav-trigger'
    };
  
    var classes = {
      isActive: 'is-active'
    };
  
    var defaults = {
      isOpen: false,
      menuLevel: 1,
      inHeader: false
    };
  
    function MobileNav(args) {
      this.config = Object.assign({}, defaults, args);
      this.namespace = '.nav-header-' + args.id;
  
      this.container = document.getElementById(this.config.id);
      if (!this.container) {
        return;
      }
  
      this.wrapper = this.container.querySelector(selectors.wrapper);
      if (!this.wrapper) {
        return;
      }
      this.nav = this.wrapper.querySelector(selectors.nav);
      this.openTriggers = document.querySelectorAll(selectors.openBtn);
  
      this.init();
    }
  
    MobileNav.prototype = Object.assign({}, MobileNav.prototype, {
      init: function() {
        this.nav.querySelectorAll(selectors.subNavToggleBtn).forEach(btn => {
          btn.addEventListener('click', this.toggleSubNav.bind(this));
        });
  
        this.nav.querySelectorAll(selectors.allLinks).forEach(link => {
          link.addEventListener('click', this.close.bind(this));
        });
  
        if (this.inHeader) {
          document.addEventListener('unmatchSmall', function() {
            this.close(null, true);
          }.bind(this));
  
          document.addEventListener('CartDrawer:open', this.close.bind(this));
          document.addEventListener('mobileNav:open', this.open.bind(this));
          document.addEventListener('mobileNav:close', this.close.bind(this));
        }
      },
      
      open: function(evt) {
        if (this.config.isOpen == true) {
          return
        }

        if (evt) {
          evt.preventDefault();
        }
  
        theme.sizeDrawer();
  
        this.openTriggers.forEach(btn => {
          btn.classList.add('is-active');
        });
  
        theme.Helpers.prepareTransition(this.container, function() {
          this.container.classList.add('is-active');
        }.bind(this));
  
        window.on('keyup' + this.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        document.documentElement.classList.add('mobile-nav-open');
        document.dispatchEvent(new CustomEvent('MobileNav:open'));
  
        this.config.isOpen = true;
  
        setTimeout(function() {
          document.querySelector('.header-sticky-wrapper').on('click' + this.namespace, function(evt) {
            this.close(evt)
          }.bind(this));
        }.bind(this), 0);
      },
  
      close: function(evt, noAnimate) {
        if (evt != null && evt.target.closest('.drawer__scrollable') || this.config.isOpen == false) {
          return
        }
        
        var forceClose = false;
        if (evt && evt.target.closest && evt.target.closest('.site-header__drawer')) {
  
          // If normal link, continue to close drawer
          if (evt.currentTarget && evt.currentTarget.classList) {
            if (evt.currentTarget.classList.contains('mobile-nav__link')) {
              forceClose = true;
            }
          }
  
          if (!forceClose) {
            return;
          }
        }

        this.openTriggers.forEach(btn => {
          btn.classList.remove('is-active');
        });
  
        if (noAnimate) {
          this.container.classList.remove('is-active');
        } else {
          theme.Helpers.prepareTransition(this.container, function() {
            this.container.classList.remove('is-active');
          }.bind(this));
        }
        
        document.documentElement.classList.remove('mobile-nav-open');
        document.dispatchEvent(new CustomEvent('MobileNav:close'));
  
        window.off('keyup' + this.namespace);
        window.off('click' + this.namespace);
        document.querySelector('.header-sticky-wrapper').off('click' + this.namespace);
  
        this.config.isOpen = false;
      },
  
      /**
       * Handle switching between nav levels
       */
      toggleSubNav: function(evt) {
        var btn = evt.currentTarget;
        this.goToSubnav(btn.dataset.target);
      },
  
      goToSubnav: function(target) {
        var targetMenu = this.nav.querySelector(selectors.childList + '[data-parent="'+ target +'"]')
        if (targetMenu) {
          this.config.menuLevel = targetMenu.dataset.level;
  
          if (this.config.menuLevel == 2) {
            this.nav.querySelectorAll(selectors.childList + '[data-level="3"]').forEach(list => {
              list.classList.remove(classes.isActive);
            });
          }
  
          targetMenu.classList.add(classes.isActive);
          this.setWrapperHeight(targetMenu.offsetHeight);
        } else {
          this.config.menuLevel = 1;
          this.wrapper.removeAttribute('style');
          this.nav.querySelectorAll(selectors.childList).forEach(list => {
            list.classList.remove(classes.isActive);
          });
        }
  
        this.wrapper.dataset.level = this.config.menuLevel;
      },
  
      setWrapperHeight: function(h) {
        this.wrapper.style.height = h + 'px';
      }
    });
  
    return MobileNav;
  })();
  
  theme.Drawers = (function() { 
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        close2: '.js-drawer-close2',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.nodes = {
        page: document.querySelector('#MainContent'),
        header: document.querySelector('#HeaderWrapper')
      };

      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }


      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        this.mobileNav = new theme.MobileNav({
          id: 'MobileNav',
          inHeader: true
        });
        
        /*
         * Setup open button(s)
         */
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('data-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this)); 

        this.announcementWrapper = document.querySelector("#AnnouncementWrapper");
        /*
         * Close modal if a drawer is opened
         */
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },

      open: function(evt, returnFocusEl) {
        this.mobileNav.open()

        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }
        
        this.mobileNav.open()

        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          evt.currentTarget.setAttribute('data-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('data-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        theme.Helpers.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);

          if (window.innerWidth > 590) {
            document.querySelector('#SiteHeader').style.zIndex = 27
          }
        }.bind(this));

        document.documentElement.classList.add(this.config.openClass);

        if (this.announcementWrapper && this.announcementWrapper.dataset.dynamic != 'true') {
          this.announcementWrapper.style.zIndex = "27";
        }

        if (this.config.id == 'MenuDrawer' && this.nodes.header.classList.contains('is-light')) {
          this.isLight = true
          this.nodes.header.classList.remove('is-light')
        }
        
        this.isOpen = true;

        slate.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

        this.bindEvents();
      },

      close: function(evt) {
        if (!this.isOpen) {
          return;
        }

        if (evt) {
          if (evt.target.closest(this.config.close) || evt.target.closest(this.config.close2)) {
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }

        this.mobileNav.close()
        
        document.activeElement.blur();

        theme.Helpers.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
          if (window.innerWidth > 590) {
            document.querySelector('#SiteHeader').style.zIndex = 28;
          }
        }.bind(this));

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);

        if (this.announcementWrapper && this.announcementWrapper.dataset.dynamic != 'true') {
          this.announcementWrapper.style.zIndex = "29";
        }
        
        window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('data-expanded')) {
            this.activeSource.setAttribute('data-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);

        this.isOpen = false;
        
        if (this.isLight) {
          this.isLight = false
          this.nodes.header.classList.add('is-light')
        }

        slate.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        this.unbindEvents();
      },
   

      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));

        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));

        slate.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);

        slate.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });

    return Drawers;
  })();

  theme.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.Cart(this.form);
        this.cartForm.buildCart();

        document.addEventListener('ajaxProduct:added', function(evt) {
          this.cartForm.buildCart();
          this.open();
        }.bind(this));

        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function() {
        this.drawer.open();
      },

      close: function() {
        this.drawer.close();
      }
    }); 
    return CartDrawer; 
  })();

  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },

    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {
        return response.text()
      });
    },

    changeItem: function(key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        }),
        type: 'application/json'
      })
    },

    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': params.type,
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(cart) {
        return cart;
      });
    },

    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        }),
        type: 'application/json'
      });
    },

    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        }),
        type: 'application/json'
      });
    },

    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }

  theme.Cart = (function() {
    var selectors = {
      products: '[data-cart-products]',
      qtySelector: '.js-qty__wrapper',
      savings: '[data-savings]',
      subTotal: '[data-cart-subtotal]',
      total: '[data-cart-total]',

      cartCountBubble: '#CartCount',
      cartNote: '[data-input-notes]',
      
      cartGiftCheckbox: '[data-gift-checkbox]',
      cartInputNote: '[data-input-notes]',

      cartDiscount: '[data-cart-discount]',
      
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout',
      cartItem: '.cart__item'
    };

    var classes = {
      btnLoading: 'btn--loading'
    };

    var config = {
      requiresTerms: false
    };

    function CartForm(form) {
      if (!form) {
        return;
      }
      
      
      this.form = form;
      this.wrapper = form.closest("#CartDrawer")
      this.container = form.closest("#CartDrawer")
      if (!this.container) {
        this.container  = form.closest("#CartPageForm")
      }

      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = this.container.querySelector(selectors.checkoutBtn)

      this.savings = this.container.querySelector(selectors.savings);
      this.subtotal = this.container.querySelector(selectors.subTotal);
      this.total = this.container.querySelector(selectors.total);

      this.totalAmount;
      
      this.cartGiftCheckbox = this.container.querySelector(selectors.cartGiftCheckbox);
      if (this.cartGiftCheckbox) {
        this.cartGiftCheckbox.removeAttribute("checked");
      	this.cartGiftForm = this.container.querySelector('#AddToCartForm-' + this.cartGiftCheckbox.value);
      }

      this.cartDiscount = this.container.querySelector(selectors.cartDiscount);

      this.termsCheckbox = this.container.querySelector(selectors.termsCheckbox);
      this.cartNote = form.querySelector(selectors.cartNote);
      this.cartInputNote = form.querySelector(selectors.cartInputNote);

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }
    
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        if (this.cartInputNote) {
          var cartInputNoteValue
          
          if (this.cartNote) {
            this.cartInputNote.addEventListener('change', function(evt) {
              var note = evt.target.value
              this.cartInputNote.value = note
              theme.cart.updateNote(note);
            }.bind(this));
          }
        }
        

        if (this.cartGiftCheckbox) {
          this.cartGiftCheckbox.addEventListener('change', function(el) {
            this._setGiftWrapping(el)
          }.bind(this));
        }

        if (this.cartDiscount) {
           this._setDiscount()
        }

        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },

      onSubmit: function(evt) {
		this.submitBtn.classList.add(classes.btnLoading);

        if (config.requiresTerms && this.submitBtn.classList.contains('cart__checkout')) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        } else {
          this.submitBtn.classList.remove(classes.btnLoading)
        } 
      },

      /**
       * Query cart page to get markup
       */
      _parseProductHTML: function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts')
        }
      },

      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function(html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = markup.discounts.dataset.savings;
        var upsellSlider = markup.upsell;

        this.updateSavings(savings);
        if (count > 0) {
          this.container.classList.remove('is-empty');
        } else {
          this.container.classList.add('is-empty');
        }

        this._setCartCountBubble(count);
        this.products.innerHTML = '';
        this.products.append(items);

        if (this.total) {
          var total = parseInt(subtotal) + parseInt(savings)
          this.total.innerHTML = theme.Currency.formatMoney(total, theme.settings.moneyFormat);
          this.totalAmount = total
        }        
        if (this.savings) {
          this.savings.innerHTML = "-" + theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
        }
        if (this.subtotal) {
          this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        }
        
        this.initQtySelectors();

        /*if (window.AOS) { AOS.refreshHard() }*/

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }

        if (localStorage.discountCode) {
          this.applyDiscount( JSON.parse(localStorage.discountCode).code);
        }
      },

      initQtySelectors: function() {
        var setGiftWrapping = false

        var items = this.form.querySelectorAll(selectors.cartItem)
        this.form.querySelectorAll(selectors.cartItem).forEach((el, index) => {
          if (!setGiftWrapping && this.cartGiftCheckbox && el.dataset.id == this.cartGiftCheckbox.value) {
            setGiftWrapping = true
            this.cartGiftCheckbox.setAttribute("checked", "true");
            el.querySelector('.cart__remove-wrapper').classList.add('hide')
            el.querySelector('.js-qty__wrapper').classList.add('hide')
            if (el.querySelector('.cart_pre-order-note')) {
              el.querySelector('.cart_pre-order-note').classList.add('hide')
            }
          }

          if (el.querySelector(".cart__item--datepicker")) {
            el.querySelector('.js-qty__wrapper').classList.add('hide')
          }

          this.container.querySelectorAll(".image-grid-item--loader.loading").forEach((el) => {
            el.classList.remove('loading', 'loading--delayed');
            el.classList.add('loaded');
          });
          

          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },

      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        if (el) {
          var qtyBtn = el.querySelector(selectors.qtySelector)
          qtyBtn.classList.add('is-loading');
        }

        theme.cart.changeItem(key, qty)
        .then(function(cart) {
          if (cart.item_count > 0) {
            this.container.classList.remove('is-empty');
          } else {           
            this.container.classList.add('is-empty'); 
          }
          
          this.buildCart();
          theme.announcementBar.update();

          

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cart: cart
            }
          }));
          
          /*
           * CUSTOM ITEM UPDATE
           */
          //updateCustomQty(el, key.split(":")[0], qty, key)
        }.bind(this))
        .catch(function(XMLHttpRequest){});
      },
      
      /**
       * Update elements of the cart
       */
      /*updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },*/

      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },

      _setGiftWrapping: function(el) {
        if (el.target.checked) {
          var data = theme.Helpers.serialize(this.cartGiftForm);

          fetch(theme.routes.cartAdd, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
          .then(response => response.json())
          .then(function(cart) {
            this.buildCart();
            theme.announcementBar.update();
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
          }.bind(this));
        } else {
          this.form.querySelectorAll(selectors.cartItem).forEach(el => {
            if (el.dataset.id == this.cartGiftCheckbox.value) {
              el.querySelector('.js-qty__adjust--empty').click()
              return
            }
          })
        }
      },

      _setCartCountBubble: function(quantity) {
        var countEl = document.querySelector('.cart-link__bubble-num');

        if (countEl) {
          countEl.innerText = quantity;
        }

        var bubbles = document.querySelector(selectors.cartCountBubble);

        if (bubbles) {
          if (quantity > 0 && bubbles.classList.contains('cart-link__bubble--visible') == false) {
            bubbles.classList.add('cart-link__bubble--visible');
          } else if (quantity == 0 && bubbles.classList.contains('cart-link__bubble--visible') == true){
            bubbles.classList.remove('cart-link__bubble--visible');
          }
        }    
      },

      _setDiscount: function() {
        this.clearBtn = this.container.querySelector(".clear-discount-btn");
        this.applyBtn = this.container.querySelector(".btn--discount");
        this.discountCodeError = this.container.querySelector(".discount-code-error");
        this.discountCodeWrapper = this.container.querySelector(".applied-discount-code-wrapper");
        this.discountCodeValue = this.container.querySelector(".applied-discount-code-value");
        this.discountCodeInput = this.container.querySelector(".input-group-field.cart__discount");
        //this.totalCartSelector = this.container.querySelector(".ajaxcart__subtotal"); // Total Cart Selector to update the total amount. 
        this.authorization_token;  

        this.discountCodeInput.classList.remove("error")
  
        this.checkoutContainer = document.createElement('div');
        document.body.appendChild(this.checkoutContainer);
          
        this.savings = this.container.querySelector(selectors.savings);
        this.subtotal = this.container.querySelector(selectors.subTotal);
        this.total = this.container.querySelector(selectors.total);
    
        if (localStorage.discountCode) {
          this.applyDiscount( JSON.parse(localStorage.discountCode).code);
        }
        
        this.applyBtn.addEventListener("click", function(e){
          e.preventDefault()
          this.applyDiscount(this.discountCodeInput.value);
        }.bind(this));
      
        this.applyBtn.addEventListener("keyup", function(event) {
            event.preventDefault();
            if (event.keyCode === 13) {
                e.preventDefault()
                this.applyDiscount(this.discountCodeInput.value);
            }
        }.bind(this));
      
        if (this.clearBtn) {
          this.clearBtn.addEventListener("click", function(e){
            //document.dispatchEvent(new CustomEvent('cart:updated'));
            this.buildCart()
            e.preventDefault()
            this.clearDiscount();
          }.bind(this));
        }
      },

      //theme.cart = {

      clearDiscount: function() {
        this.discountCodeValue.innerHTML = "";
        //discountCodeError.innerHTML = "";
        this.clearLocalStorage();
        fetch("/discount/CLEAR")
        /*.then(function(response) {
        //.then(response => {
          console.log("Response")
          this.buildCart()
        }.bind(this))*/
        //.catch(function(XMLHttpRequest){});

        
      },
    
      clearLocalStorage: function() {
        this.discountCodeWrapper.style.display = "none";
        /*console.log("totalCartSelector")
        console.log(JSON.parse(localStorage.discountCode))
        console.log(JSON.parse(localStorage.discountCode).totalCart)*/
        //this.totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
        localStorage.removeItem("discountCode");
      },

      applyDiscount: function(code) {
        //this.applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
        //this.applyBtn.style.pointerEvents = "none";

        this.applyBtn.classList.add("btn--loading")
        
        this.applyBtn.style.pointerEvents = "none";
        fetch("/payments/config", {"method": "GET"})
        .then(function(response) { return response.json() })
        .then(function(data) {
            const checkout_json_url = '/wallets/checkouts/';
            this.authorization_token = btoa(data.paymentInstruments.accessToken)
            fetch('/cart.js', {}).then(function(res){return res.json();})
            .then(function(data){
            
            let body = {"checkout": {"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active}}
            console.log(body)
              fetch(checkout_json_url, {
              "headers": {
              "accept": "*/*", "cache-control": "no-cache",
              "authorization": "Basic " + this.authorization_token,
              "content-type": "application/json, text/javascript",
              "pragma": "no-cache", "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
            },
            "referrerPolicy": "strict-origin-when-cross-origin",
            "method": "POST", "mode": "cors", "credentials": "include",
            "body": JSON.stringify(body)
          })
          .then(function(response) { return response.json() })
          .then(function(data) {
            console.log(data.checkout);
            if(data.checkout && data.checkout.applied_discounts.length > 0){
              let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
              fetch(discountApplyUrl, {}).then(function(response) { return response.text(); })
              //this.discountCodeWrapper.style.display = "inline";

              this.discountCodeError.classList.add("hide")
              //this.discountCodeError.innerHTML = "";
              //this.discountCodeValue.innerHTML = data.checkout.applied_discounts[0].title + " (" + data.checkout.applied_discounts[0].amount + ' ' + Shopify.currency.active + ")";
              this.discountCodeWrapper.style.display = "inline";
              this.dataCheckout = data.checkout
              this.discountCodeValue.innerHTML = data.checkout.applied_discounts[0].title
              let localStorageValue = {
                'code': code.trim(),
                'totalCart': data.checkout.total_line_items_price
              };
              localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
              //this.totalCartSelector.innerHTML = "<s>" + data.checkout.total_line_items_price + "</s>" + data.checkout.total_price;
              //this.savings.innerHTML 

              this.container.querySelectorAll(selectors.cartItem).forEach((el, i) => {
                
                //console.log(data.checkout.line_items)
                if (data.checkout.line_items && data.checkout.line_items[i].discount_allocations.length > 0) {
                  var quantity = parseInt(data.checkout.line_items[i].quantity)
                  var discountAmount = data.checkout.line_items[i].discount_allocations[0].amount
                  var discountPrice = (parseFloat(data.checkout.line_items[i].line_price) - parseFloat(discountAmount)).toFixed(2).toString()
                  var discountDescription = data.checkout.line_items[i].discount_allocations[0].description

                  if (el.querySelector(".cart__price").classList.contains("cart__price--strikethrough")) {

                  } else {  
                    var priceStriketrough = document.createElement('small')
                    priceStriketrough.className = "cart__price cart__price--strikethrough"
                    priceStriketrough.innerHTML = theme.Currency.formatMoney(data.checkout.line_items[i].line_price, theme.settings.moneyFormat);
                    var parentNode = el.querySelector(".cart__item--price")
                    parentNode.insertBefore(priceStriketrough, parentNode.firstChild);

                    
                    el.querySelector(".cart__discount").classList.remove("hide")
                    //el.querySelector(".cart__discount").innerHTML = '<small class="cart__discount-text">' + + '(-<span class="cart__discount-price">' +  + '</span>)</small>'
                    el.querySelector(".cart__discount").innerHTML += '<small class="cart__discount-text"><span class="cart__discount-price"></span></small>'
                    //el.querySelector(".cart__discount")
                  }


                  el.querySelector(".cart__price--final").innerHTML = theme.Currency.formatMoney(discountPrice, theme.settings.moneyFormat)
                  el.querySelector(".cart__discount-text").innerHTML = discountDescription + " (-" + theme.Currency.formatMoney(discountAmount, theme.settings.moneyFormat) + ")"
                  
                  
                } else if(el.querySelector(".cart__price").classList.contains("cart__price--strikethrough")) {
                  el.querySelector(".cart__discount").classList.add("hide")
                  
                  el.querySelector(".cart__price--strikethrough").classList.add("hide")
                  el.querySelector(".cart__price--final").innerHTML = theme.Currency.formatMoney(data.checkout.line_items[i].line_price, theme.settings.moneyFormat)
                }

                if (this.total) {
                  this.total.innerHTML = theme.Currency.formatMoney(data.checkout.total_line_items_price, theme.settings.moneyFormat);
                }        
                if (this.savings) {
                  this.savings.innerHTML = "-" + theme.Currency.formatMoney(data.checkout.total_line_level_discount, theme.settings.moneyFormat);
                }
                if (this.subtotal) {
                  this.subtotal.innerHTML = theme.Currency.formatMoney(data.checkout.total_price, theme.settings.moneyFormat);
                }
              });
            } else{
              this.discountCodeValue.innerHTML = "";
              this.clearLocalStorage();
              //this.discountCodeError.innerHTML = "Please Enter Valid Coupon Code."
              this.discountCodeError.classList.remove("hide")
              this.discountCodeInput.classList.add("error")
            }
          }.bind(this)).finally(function(params) {
            this.applyBtn.classList.remove("btn--loading")
              this.discountCodeInput.value = ""
              this.applyBtn.style.pointerEvents = "all";
            //this.applyBtn.innerHTML = "APPLY";
            //this.applyBtn.style.pointerEvents = "all";
          }.bind(this));
        }.bind(this));
      }.bind(this));
    }
    });

    return CartForm;
  })();

  theme.cartPage = function() {
    var selectors = {
      checkoutBtn: '.cart__checkout',
      qtySelector: '.js-qty__wrapper'
    };

    var classes = {
      checkoutBtn: 'cart__checkout',
      cartNote: 'cart-notes',
      btnLoading: 'btn--loading'
    }

    var config = {
      namespace: '.cartpage'
    };

    var container = document.getElementById('CartPageForm');
    
    var cartInputNoteValue = '';

    function init() {
      document.addEventListener('click', function(evt) {
        if (evt.target && evt.target.classList.contains(classes.checkoutBtn)){
          evt.target.classList.add(classes.btnLoading);

          var termsCheckboxId = evt.target.dataset.terms;
          if (termsCheckboxId) {
            var isChecked = document.getElementById(termsCheckboxId).checked;

            if (isChecked) {
              // Load checkout
            } else {
              alert(theme.strings.cartTermsConfirmation);
              evt.target.classList.remove(classes.btnLoading)
              evt.preventDefault();
              return false;
            }
          }
        }
      });

      if (container) {
        initCartForm();
      }
    }

    function initCartForm() {
      container.querySelectorAll(selectors.qtySelector).forEach(el => {
        var selector = new theme.QtySelector(el, {
          namespace: config.namespace
        });
      });

      document.addEventListener('cart:quantity' + config.namespace, function(evt) {
        document.getElementById('CartPageUpdate').click();
      });
    }

    return {
      init: init
    };
  }();

  function DOMProductready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMProductready(function(){
    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.Cart(cartPageForm);
      }
    }
  });
})();